import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
import React, { useEffect, useState } from 'react';
import { getFeatures } from '../common/api/featuresApi';
import { FeatureResponseDefault } from 'self-service-api/constants/FeatureStore';
import { MARKETING } from 'self-service-api/constants/ProductLines';
export const FeaturesContext = /*#__PURE__*/React.createContext({
  features: FeatureResponseDefault,
  highlightedProducts: [],
  productLine: MARKETING
});

const FeaturesProvider = ({
  children,
  highlightedProducts,
  productLine,
  passedInFeatures = {}
}) => {
  const [features, setFeatures] = useState(passedInFeatures);
  useEffect(() => {
    // Check if we already have the productLine features, if not fetch them
    const needsFetch = !features[productLine];

    if (needsFetch) {
      getFeatures({
        highlightedProducts,
        productLine
      }).then(res => {
        if (res) {
          setFeatures(Object.assign({}, features, {}, res));
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedProducts, productLine]);
  return /*#__PURE__*/_jsx(FeaturesContext.Provider, {
    value: {
      features,
      highlightedProducts,
      productLine
    },
    children: children
  });
};

export default FeaturesProvider;